import React, { useEffect, useState } from "react";
import styles from "./unconnected-parent.module.css";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomTable from "../../../../common/custom-table/custom-table";
import { Button, Spin } from "antd";
import { getUnconParentList } from "../../../../services/dashboard";
import { PAGE_LIMIT } from "../../../../constants/common";

const UnregisteredParentCard = ({ onAddParent }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData([]);
    fetchParentList();
  }, []);

  const fetchParentList = async () => {
    try {
      setLoading(true);
      const payload = {
        page: 1,
        pageSize: PAGE_LIMIT,
      };
      const resp = await getUnconParentList(payload);
      const responceData = resp?.data;

      setTableData(responceData?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Reg No.",
      dataIndex: "reg_number",
      key: "reg_number",
      sorter: (a, b) => a.reg_number.localeCompare(b.reg_number),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Student Name",
      dataIndex: "full_name",
      key: "full_name",
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      sorter: (a, b) => a.level.localeCompare(b.level),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
      sorter: (a, b) => a.class.localeCompare(b.class),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Contact Info",
      dataIndex: "phone_number",
      key: "phone_number",
      sorter: (a, b) => a.phone_number.localeCompare(b.phone_number),
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          style={{ color: "#39B54A", fontWeight: 500, fontSize: "14px" }}
          onClick={() => onAddParent(record)}
        >
          + Add Parent
        </Button>
      ),
    },
  ];

  return (
    <CustomCard style={{ height: 300 }}>
    
      <div className={styles.topBar}>
        <span className={styles.card_heading}>
          Unregistered Parents Summary
        </span>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>
     
      <div className={styles.tableWrapper}>
        <Spin spinning={loading}>
          <CustomTable
            columns={columns}
            dataSource={tableData}
            pagination={false}
          />
        </Spin>
      </div>
    </CustomCard>
  );
};

export default UnregisteredParentCard;
